// extracted by mini-css-extract-plugin
export default {"loading":"LoadingScreen_loading__ZOVA2"};